function t(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return e;
  }
}
export {
  t as gracefulDecodeURIComponent
};
//# sourceMappingURL=index74.js.map
